module.exports = __webpack_public_path__ + "img/index_intro_sm03.4345e6b9.jpg";